import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { Radio } from 'antd';
export var RadioGroup = styled(Radio.Group)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  ", ";\n"])), function (props) {
  return props.fullWidth && "\n    && {\n      display: flex;\n    }\n\n    .ant-radio-button-wrapper {\n      flex: 1;\n      text-align: center;\n    }\n  ";
}, function (props) {
  return props.block && "\n    && {\n      display: block;\n    }\n  ";
});
export default RadioGroup;